module.exports = __webpack_public_path__ + "assets/media/client_training_10sec.a0abb916.mp4";